import { DEFAULT_TIMEZONE } from './constants.ts';

/*
 * Local formats for the UI (El Salvador): dates dd/mm/aaaa in the tenant's time
 * zone, money in USD, phones +503 XXXX-XXXX. Timestamps are stored in UTC.
 */

const LOCALE = 'es-SV';

/** 26/09/2026 */
export function formatDate(value: Date | string, timeZone = DEFAULT_TIMEZONE): string {
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(value));
}

/** 26/09/2026 21:40 (24 h) */
export function formatDateTime(value: Date | string, timeZone = DEFAULT_TIMEZONE): string {
  const parts = new Intl.DateTimeFormat(LOCALE, {
    timeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(value));
  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((p) => p.type === type)?.value ?? '';
  return `${get('day')}/${get('month')}/${get('year')} ${get('hour')}:${get('minute')}`;
}

/** 21:40 */
export function formatTime(value: Date | string, timeZone = DEFAULT_TIMEZONE): string {
  return new Intl.DateTimeFormat(LOCALE, {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(new Date(value));
}

/**
 * $1,234.50. Amounts arrive from the API as decimal strings (numeric(14,2)); they are
 * formatted as strings, without going through a float.
 */
export function formatMoney(amount: string | number, currency = 'USD'): string {
  const format = new Intl.NumberFormat(LOCALE, { style: 'currency', currency });
  // Intl formats decimal strings exactly (no float rounding).
  return format.format(amount as unknown as number);
}

/** +503 7123-4567 for Salvadoran numbers (8 digits, with or without +503); others as typed. */
export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  const local = digits.length === 11 && digits.startsWith('503') ? digits.slice(3) : digits;
  if (local.length === 8 && /^[2-9]/.test(local))
    return `+503 ${local.slice(0, 4)}-${local.slice(4)}`;
  return phone.trim();
}
